import { gql } from '@apollo/client';
import { client as apolloClient } from '@xbcb/apollo-client';

const SEARCH_SHIPMENTS_BY_BOOKING_PREFIX_QUERY = gql`
  query SearchShipments($input: SearchShipmentInput!) {
    searchShipments(input: $input) {
      results {
        clientReferences {
          bookingId
        }
      }
    }
  }
`;

const SEARCH_SHIPMENTS_BY_CONTAINER_PREFIX_QUERY = gql`
  query SearchShipments($input: SearchShipmentInput!) {
    searchShipments(input: $input) {
      results {
        legs {
          containers {
            externalId
            number
          }
        }
      }
    }
  }
`;

export const searchBookingsByPrefix = async (
  bookingPrefix: string,
): Promise<string[]> => {
  try {
    const { data } = await apolloClient.query({
      query: SEARCH_SHIPMENTS_BY_BOOKING_PREFIX_QUERY,
      variables: {
        input: {
          searchCriteria: {
            bookingId: {
              operator: 'STARTS_WITH',
              values: [bookingPrefix],
            },
          },
          paginationOptions: {
            pageSize: 10,
          },
        },
      },
    });

    const bookingIds = (data?.searchShipments?.results as unknown[] | undefined)
      ?.map(
        (result) =>
          (result as { clientReferences?: { bookingId?: string } })
            ?.clientReferences?.bookingId,
      )
      .filter((id): id is string => id !== undefined);

    return bookingIds || [];
  } catch (error) {
    console.error(
      `Failed to search bookings with prefix ${bookingPrefix}:`,
      error,
    );
    return [];
  }
};

export const searchContainersByPrefix = async (
  containerPrefix: string,
): Promise<string[]> => {
  try {
    const { data } = await apolloClient.query({
      query: SEARCH_SHIPMENTS_BY_CONTAINER_PREFIX_QUERY,
      variables: {
        input: {
          searchCriteria: {
            containerNumber: {
              operator: 'STARTS_WITH',
              values: [containerPrefix],
            },
          },
          paginationOptions: {
            pageSize: 10,
          },
        },
      },
    });

    const containers = (data?.searchShipments?.results as unknown[] | undefined)
      ?.flatMap((result) =>
        (result as { legs?: unknown[] })?.legs?.flatMap((leg) =>
          (leg as { containers?: unknown[] })?.containers?.map((container) => {
            const { number, externalId } = container as {
              number?: string;
              externalId?: string | null;
            };
            return number ? `${number}_${externalId || ''}` : null;
          }),
        ),
      )
      .filter((container): container is string => container !== null);

    return containers || [];
  } catch (error) {
    console.error(
      `Failed to search containers with prefix ${containerPrefix}:`,
      error,
    );
    return [];
  }
};
